/* eslint-disable no-console */
import dayjs from "dayjs";
import { json2csv } from "json-2-csv";
import { client } from "../../../../Utils/axiosClient";
import { exportFarmerColumns } from "./data";
import { updateRevenue } from "../../../../Redux/Slices/revenue.slice";
import capitalize from "../../../../Utils/capitalize";

const modified = (data) => {
  if (!data?.length) return [];

  const changed = data?.map((item) => {
    const date = dayjs(item.submittedAt).format("DD-MM-YYYY");

    let total = 0;
    let commodity = "";
    let rate = 0;
    let weight = 0;

    if (item?.produceDetails?.length) {
      commodity = item.produceDetails[0].produceName;
      rate = item.produceDetails[0].paymentRate;
      weight = item.produceDetails[0].weightCollected;

      total = item?.produceDetails?.reduce((acc, current) => {
        acc += parseFloat(current.amount);
        return acc;
      }, 0);
    }

    return {
      date,
      total: total > 0 ? `${total} KSH` : "",
      farmerName: `${capitalize(item?.firstName || "")} ${capitalize(
        item?.lastName || "",
      )}`,
      tripId: item.tripId,
      farmerId: item.farmerId,
      commodity,
      weight,
      rate: rate > 0 ? `${rate} KSH/Per Litre` : "",
    };
  });

  return changed?.length ? changed : [];
};

const handleFarmerExport = async ({
  farmerIds,
  startDate = "",
  endDate = "",
  dispatch,
  closeDrawer,
}) => {
  try {
    dispatch(
      updateRevenue({
        key: "loading",
        value: true,
      }),
    );

    const localFarmerIds = farmerIds.join(",");

    const payload = {
      farmerIds: localFarmerIds,
      startDate: startDate || "",
      endDate: endDate || "",
    };

    const response = await client.post(
      `${process.env.REACT_APP_API_URL}/revenue/export-farmer`,
      payload,
    );

    if (response.status === 200) {
      if (!response?.data?.result?.length) {
        closeDrawer();

        dispatch(
          updateRevenue({
            key: "showToastMessage",
            value: {
              visible: true,
              data: {
                title: "No Data Found",
                description: "No data available for selected time period.",
                type: "error",
              },
            },
          }),
        );

        return;
      }

      const updatedData = modified(response?.data?.result);

      const data = json2csv(updatedData, {
        emptyFieldValue: "--",
        keys: exportFarmerColumns,
      });

      const blob = new Blob([data], { type: "text/csv;charset=utf-8;" });

      const link = document.createElement("a");

      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", `${new Date()}.csv`);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      closeDrawer();

      dispatch(
        updateRevenue({
          key: "showToastMessage",
          value: {
            visible: true,
            data: {
              title: "Farmer Data Exported.",
              description: "Farmer data exported successfully.",
              type: "success",
            },
          },
        }),
      );
    }
  } catch (error) {
    console.log(error);
  } finally {
    dispatch(
      updateRevenue({
        key: "loading",
        value: false,
      }),
    );
  }
};

export default handleFarmerExport;
